import $ from 'jquery';

function whichTransitionEvent() {
    var el = document.createElement('fake'),
        transEndEventNames = {
            'WebkitTransition' : 'webkitTransitionEnd',// Saf 6, Android Browser
            'MozTransition'    : 'transitionend',      // only for FF < 15
            'transition'       : 'transitionend'       // IE10, Opera, Chrome, FF 15+, Saf 7+
        };

    for(var t in transEndEventNames){
        if( el.style[t] !== undefined ){
            return transEndEventNames[t];
        }
      }
    }

  var transEndEventName = whichTransitionEvent();

  // $(this).one(transEndEventName, function(e) {
  // });

module.exports = transEndEventName;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/transitionend.js